<div class="ask">
  <div class="card-pad">
    <div *ngFor="let tbl of model.tbls; let i=index;" class="card">
      <div class="card-header">{{tbl.scm + '.' + tbl.nam + ' [' + tbl.als + ']'}}</div>
      <div class="card-body">
        <ul>
          <li *ngFor="let cinf of tbl.cinfos">{{cinf.column_name}}</li>
        </ul>
      </div>
      <div class="card-footer">{{(tbl.jtyp || '') + ' - ' + (tbl.jval || '')}}</div>
    </div>
  </div>
  <br>
  <div class="row condition">
    <div class="col"><label>where: </label> <input type="text"></div>
    <div class="col"><label>having: </label> <input type="text"></div>
  </div>
</div>